export default "__VITE_ASSET__DKbQs_Am__"